module.exports = __webpack_public_path__ + "static/img/qpyx_active.7ea8186c.png";